import { Message } from '@/types/chat';

export interface ParsedMessage {
  cleanContent: string;
  options: string[];
  hasSearchReady: boolean;
  hasMentorQuery: boolean;
  metadata: {
    originalContent: string;
    tags: string[];
  };
}

const TAG_PATTERNS = {
  OPTIONS: /\[OPTIONS\](.*?)\[\/OPTIONS\]/gs,
  // ✅ חשוב: בלי g כדי ש-test() לא יהיה stateful וישבור זיהוי תגיות
  SEARCH_READY: /\[SEARCH_READY\]/,
  MENTOR_QUERY: /\[MENTOR_QUERY\]/,
} as const;

export function parseMessage(content: string): ParsedMessage {
  let cleanContent = content;
  const options: string[] = [];
  const tags: string[] = [];

  const optionsMatch = content.match(TAG_PATTERNS.OPTIONS);
  if (optionsMatch) {
    optionsMatch.forEach((match) => {
      const optionsContent = match.replace(/\[OPTIONS\]|\[\/OPTIONS\]/g, '');
      const parsedOptions = optionsContent
        .split('|')
        .map(opt => opt.trim())
        .filter(opt => opt.length > 0);

      options.push(...parsedOptions);
      tags.push('OPTIONS');
    });

    cleanContent = cleanContent.replace(TAG_PATTERNS.OPTIONS, '').trim();
  }

  const hasSearchReady = TAG_PATTERNS.SEARCH_READY.test(content);
  if (hasSearchReady) {
    tags.push('SEARCH_READY');
    cleanContent = cleanContent.replace(TAG_PATTERNS.SEARCH_READY, '').trim();
  }

  const hasMentorQuery = TAG_PATTERNS.MENTOR_QUERY.test(content);
  if (hasMentorQuery) {
    tags.push('MENTOR_QUERY');
    cleanContent = cleanContent.replace(TAG_PATTERNS.MENTOR_QUERY, '').trim();
  }

  return {
    cleanContent,
    options,
    hasSearchReady,
    hasMentorQuery,
    metadata: {
      originalContent: content,
      tags,
    },
  };
}

export function extractOptions(content: string): string[] {
  const match = content.match(TAG_PATTERNS.OPTIONS);
  if (!match) return [];

  return match[0]
    .replace(/\[OPTIONS\]|\[\/OPTIONS\]/g, '')
    .split('|')
    .map(opt => opt.trim())
    .filter(opt => opt.length > 0);
}

export function removeAllTags(content: string): string {
  let cleaned = content;

  Object.values(TAG_PATTERNS).forEach(pattern => {
    cleaned = cleaned.replace(pattern as any, '');
  });

  return cleaned.trim();
}

export function hasTag(content: string, tag: keyof typeof TAG_PATTERNS): boolean {
  return TAG_PATTERNS[tag].test(content);
}

export function parseMessageBatch(messages: Message[]): ParsedMessage[] {
  return messages.map(msg => parseMessage(msg.content));
}
